module.exports = __webpack_public_path__ + "static/media/times-octagon.90a28411.svg";